import { render } from "./ProjectDetailsView.vue?vue&type=template&id=4f3bd3cc&scoped=true"
import script from "./ProjectDetailsView.vue?vue&type=script&lang=js"
export * from "./ProjectDetailsView.vue?vue&type=script&lang=js"

import "./ProjectDetailsView.vue?vue&type=style&index=0&id=4f3bd3cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f3bd3cc"]])

export default __exports__